import React, {useEffect, useState} from 'react';
import {taskCheck, taskAdd} from "../../../http/taskApi";
import Spiner from "../spiner/Spiner";

const Tools = () => {
    const [showPreloader,setShowPreloader] = useState(false);
    const [showText,setShowText] = useState('');
    const [currentTask,setCurrentTask] = useState(false);

    let timer = null;
    const addTask = (task) => {
        setShowPreloader(true)
        taskCheck(task).then(response => {
            if(response.status === true){
                taskAdd(task).then(response => {
                    setShowText('Задача добавлена')
                    setShowPreloader(false)
                })
            } else {
                setShowText('Задача выполняется')
                setShowPreloader(false)
            }

            setCurrentTask(task)
            timer = setInterval(checkStatus, 1000)
        })
    }

    const checkStatus = () => {
        console.log(currentTask)
        if(currentTask){
            taskCheck(currentTask).then(response => {
                if(response.status === true){
                    clearInterval(timer)
                    setShowText('Задача выполнена')
                    setCurrentTask(false)
                }
            })
        } else {
            clearInterval(timer)
        }
    }

    return (
        <div className={"users_page_wrapper"}>
            <div className={"wrapper_all_users"}>
                  <span className={"user_list_page_heading"}>
                         Инструменты
                  </span>
                {
                    showText ? <span className={"user_list_page_heading_warning"}>{showText}</span>:''
                }
                {
                    showPreloader ?
                        <Spiner />
                        :
                        <div className={"controll_and_sort_users_list"}>
                            <div className={"wrapper_for_role_button"}>
                                <span onClick={e => addTask('imshop_feed')} className={"role_button_users"}>Сгенерировать фид</span>

                            </div>
                        </div>
                }

            </div>
        </div>
    )
}

export default Tools;